import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {ReactiveFormsModule} from "@angular/forms";
import {RouterModule, Routes} from "@angular/router";
import {FlyCommonModule} from "fly-common/fly-common.module";
import {DeviceManagementCommonModule} from "../common/device-management-common.module";
import {SharedModule} from "../shared/shared.module";
import {DeviceOptionsComponent} from "./device-options.component";
import {GroupOptionsComponent} from "./group-options.component";
import {RedemptionComponent} from "./redemption.component";

const routes: Routes = [
	{path: "", component: RedemptionComponent},
];

@NgModule({
	imports: [
		CommonModule,
		FlyCommonModule,
		DeviceManagementCommonModule,
		ReactiveFormsModule,
		RouterModule.forChild(routes),
		SharedModule,
	],
	declarations: [
		DeviceOptionsComponent,
		GroupOptionsComponent,
		RedemptionComponent,
	],
	exports: [
		RouterModule,
	],
})
export class RedemptionModule {}
